<template>
  <div id="app" :style="appStyle">
    <div class="safe-area-top"></div>
    <div class="maxWidth">
      <router-view />
    </div>
    <!-- <Kefu /> -->
  </div>
</template>
<script>
export default {
  // components: { Kefu },
  data() {
    return {
      notchTop: 0,
    };
  },
  computed: {
    appStyle() {
      const safeAreaTop =
        this.notchTop > 0
          ? `${this.notchTop}px`
          : "env(safe-area-inset-top, 0px)";
      return {
        "--safe-area-top": safeAreaTop,
      };
    },
  },
  mounted() {
    this.updateNotchTop();
    window.addEventListener("notchInfoChanged", this.updateNotchTop);
    localStorage.setItem("locale", "VI");
    this.$store.state.lang = "VI";
    // document.addEventListener(
    //   "keydown",
    //   function (event) {
    //     if (
    //       (event.ctrlKey === true || event.metaKey === true) &&
    //       (event.keyCode === 61 ||
    //         event.keyCode === 107 ||
    //         event.keyCode === 173 ||
    //         event.keyCode === 109 ||
    //         event.keyCode === 187 ||
    //         event.keyCode === 189)
    //     ) {
    //       event.preventDefault();
    //     }
    //   },
    //   false
    // );
    document.addEventListener(
      "mousewheel",
      function (e) {
        e = e || window.event;
        // @ts-ignore
        if ((e.wheelDelta && event.ctrlKey) || e.detail) {
          event.preventDefault();
        }
      },
      {
        capture: false,
        passive: false,
      }
    );
    // 添加 resize 事件监听器
    // window.addEventListener("resize", this.checkResize);
  },
  beforeDestroy() {
    window.removeEventListener("notchInfoChanged", this.updateNotchTop);
    // 组件销毁前移除事件监听器
    // window.removeEventListener("resize", this.checkResize);
  },
  methods: {
    updateNotchTop() {
      const notchInfo = window.__notchInfo || {};
      this.notchTop = notchInfo.hasNotch ? Number(notchInfo.top || 0) : 0;
    },
    // checkResize() {
    //   if (window.innerWidth !== this.lastWidth) {
    //     this.lastWidth = window.innerWidth; // 更新 lastWidth
    //     location.reload(); // 刷新页面
    //   }
    // },
  },
};
</script>

<style lang="scss">
*::-webkit-scrollbar {
  position: absolute;
  left: 0;
  width: 3px;
  height: 0;
  display: none;
}

*::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #ddd;
}
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  scroll-behavior: smooth;
  background-color: #ffffff;
}
#app {
  min-height: 100%;
  box-sizing: border-box;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  scroll-behavior: smooth;
  padding-top: var(--safe-area-top, env(safe-area-inset-top, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px);
  overflow: auto;
  background-color: #ffffff;
  position: relative;
}
.safe-area-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--safe-area-top, env(safe-area-inset-top, 0px));
  background-color: #ffffff;
  z-index: 1001;
  pointer-events: none;
}

a {
  text-decoration: none;
}
input,
textarea {
  -webkit-user-select: auto !important;
  -khtml-user-select: auto !important;
  -moz-user-select: auto !important;
  -ms-user-select: auto !important;
  -o-user-select: auto !important;
  user-select: auto !important;
}

.icon,
.iconfont {
  font-family: "iconfont" !important;
  font-size: 20px !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
.maxWidth {
  max-width: 600px;
  min-height: 100%;
  margin: 0 auto;
  background-color: #f6f7f9;
  overflow: auto;
  box-sizing: border-box;
}
.van-cell__title {
  text-align: left;
}
.navBar {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  background-color: #ffffff;
  z-index: 1000;
}
/deep/.el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}
@media screen and (max-width: 1024px) {
  .navBar {
    width: 100%;
  }
}
</style>
